import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    ColorFill: {
        fill: '#f58220'
    }
});

const SettingButton = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);

    return (
        <>
            <div style={{ width: '90px' }}>
                <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 188.7 60.6"
                >
                    <g>
                        <path
                            className={classesInline.ColorFill}
                            d="M45.4,27.4c-2.1,0-3.7,1.3-4.1,3.7h8.2C49.5,28.8,47.7,27.4,45.4,27.4z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M111.3,27.6c-2.3,0-4.5,1.7-4.5,5s2.2,5.1,4.5,5.1c2.4,0,4.6-1.8,4.6-5.1C115.9,29.4,113.7,27.6,111.3,27.6z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M187.2,0H1.4C0.6,0,0,0.7,0,1.4v57.7c0,0.8,0.6,1.4,1.4,1.4h185.8c0.8,0,1.4-0.6,1.4-1.4V1.4
		C188.7,0.7,188,0,187.2,0z M28,41.5c-4.5,0-8-2.4-8-6.5h4.7c0.1,1.7,1.3,2.9,3.3,2.9c2,0,3.3-1.1,3.3-2.6c0-4.7-11.2-1.9-11.1-9.7
		c0-3.9,3.2-6.3,7.6-6.3c4.4,0,7.5,2.3,7.8,6.2h-4.8c-0.1-1.4-1.2-2.5-3.1-2.6c-1.7-0.1-3,0.8-3,2.5c0,4.3,11.1,1.9,11.1,9.6
		C35.7,38.4,33,41.5,28,41.5z M53.9,34H41.3c0.2,2.5,2,4,4.1,4c1.9,0,2.9-0.9,3.4-2.1h4.7c-0.9,3.2-3.8,5.7-8,5.7
		c-5,0-8.6-3.5-8.6-8.9c0-5.4,3.5-8.9,8.6-8.9c5,0,8.5,3.4,8.5,8.5C54,32.9,54,33.4,53.9,34z M64.7,27.6h-3.8V36
		c0,1.1,0.5,1.6,1.8,1.6h2v3.7H62c-3.3,0-5.5-1.4-5.5-5.3v-8.3h-2v-3.6h2v-4.3h4.4v4.3h3.8V27.6z M75.4,27.6h-3.8V36
		c0,1.1,0.5,1.6,1.8,1.6h2v3.7h-2.7c-3.3,0-5.5-1.4-5.5-5.3v-8.3h-2v-3.6h2v-4.3h4.4v4.3h3.8V27.6z M81.4,41.3h-4.3V24.1h4.3V41.3z
		 M79.3,22c-1.6,0-2.7-1.1-2.7-2.5s1.1-2.5,2.7-2.5c1.5,0,2.7,1.1,2.7,2.5S80.8,22,79.3,22z M100.7,41.3h-4.3v-9.5
		c0-2.8-1.5-4.3-3.8-4.3c-2.4,0-3.9,1.5-3.9,4.3v9.5h-4.3V24.1h4.3v2.1c1.1-1.5,3-2.4,5.2-2.4c4,0,6.9,2.6,6.9,7.4V41.3z
		 M120.2,41.4c0,4.7-2.9,8.3-8.5,8.3c-4.8,0-8.2-2.4-8.7-6.4h4.3c0.4,1.6,2,2.6,4.2,2.6c2.4,0,4.3-1.4,4.3-4.6v-2.7
		c-1,1.5-3,2.8-5.7,2.8c-4.4,0-7.9-3.6-7.9-8.9s3.5-8.8,7.9-8.8c2.7,0,4.7,1.2,5.7,2.7v-2.5h4.4V41.4z M152.3,49.2
		c-10.4,0-18.9-8.5-18.9-18.9s8.5-18.9,18.9-18.9s18.9,8.5,18.9,18.9S162.8,49.2,152.3,49.2z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M163.3,27.7l-1.7-0.3c-0.2-0.6-0.4-1.1-0.7-1.7l1-1.4c0.4-0.6,0.4-1.4-0.2-1.9l-1.5-1.5
		c-0.3-0.3-0.7-0.4-1.1-0.4c-0.3,0-0.6,0.1-0.9,0.3l-1.4,1c-0.6-0.3-1.1-0.5-1.7-0.7l-0.3-1.7c-0.1-0.7-0.7-1.3-1.5-1.3h-2.1
		c-0.7,0-1.4,0.5-1.5,1.3l-0.3,1.7c-0.6,0.2-1.1,0.4-1.7,0.7l-1.4-1c-0.3-0.2-0.6-0.3-0.9-0.3c-0.4,0-0.8,0.2-1.1,0.4l-1.5,1.5
		c-0.5,0.5-0.6,1.3-0.2,1.9l1,1.4c-0.3,0.5-0.5,1.1-0.7,1.7l-1.7,0.3c-0.7,0.1-1.3,0.7-1.3,1.5v2.1c0,0.7,0.5,1.4,1.3,1.5l1.7,0.3
		c0.2,0.6,0.4,1.1,0.7,1.7l-1,1.4c-0.4,0.6-0.4,1.4,0.2,1.9l1.5,1.5c0.3,0.3,0.7,0.4,1.1,0.4c0.3,0,0.6-0.1,0.9-0.3l1.4-1
		c0.5,0.3,1.1,0.5,1.6,0.7l0.3,1.7c0.1,0.7,0.7,1.3,1.5,1.3h2.1c0.7,0,1.4-0.5,1.5-1.3l0.3-1.7c0.6-0.2,1.1-0.4,1.7-0.7l1.4,1
		c0.3,0.2,0.6,0.3,0.9,0.3c0.4,0,0.8-0.2,1.1-0.4l1.5-1.5c0.5-0.5,0.6-1.3,0.2-1.9l-1-1.4c0.3-0.5,0.5-1.1,0.7-1.7l1.7-0.3
		c0.7-0.1,1.3-0.7,1.3-1.5v-2.1C164.5,28.5,164,27.9,163.3,27.7z M163.2,31.4L163.2,31.4c0,0.1-0.1,0.1-0.1,0.1l-2.1,0.4
		c-0.3,0-0.5,0.2-0.6,0.5c-0.2,0.7-0.5,1.5-0.9,2.1c-0.1,0.2-0.1,0.5,0,0.7l1.3,1.8c0,0.1,0,0.1,0,0.2l-1.5,1.5c0,0-0.1,0-0.1,0
		c0,0-0.1,0-0.1,0l-1.8-1.3c-0.2-0.2-0.5-0.2-0.7,0c-0.7,0.4-1.4,0.7-2.1,0.9c-0.3,0.1-0.5,0.3-0.5,0.6l-0.4,2.1
		c0,0.1-0.1,0.1-0.1,0.1h-2.1c-0.1,0-0.1,0-0.1-0.1l-0.4-2.1c0-0.3-0.2-0.5-0.5-0.6c-0.7-0.2-1.4-0.5-2.1-0.9
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.3,0-0.4,0.1l-1.8,1.3c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0l-1.5-1.5c0,0-0.1-0.1,0-0.2l1.3-1.8
		c0.2-0.2,0.2-0.5,0-0.8c-0.4-0.7-0.7-1.4-0.9-2.1c-0.1-0.3-0.3-0.5-0.6-0.5l-2.2-0.4c-0.1,0-0.1-0.1-0.1-0.1v-2.1
		c0-0.1,0-0.1,0.1-0.1l2.1-0.4c0.3,0,0.5-0.2,0.6-0.5c0.2-0.7,0.5-1.5,0.9-2.1c0.1-0.2,0.1-0.5,0-0.7l-1.3-1.8c0-0.1,0-0.1,0-0.2
		l1.5-1.5c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l1.8,1.3c0.2,0.2,0.5,0.2,0.8,0c0.7-0.4,1.4-0.7,2.1-0.9c0.3-0.1,0.5-0.3,0.5-0.6l0.4-2.2
		c0-0.1,0.1-0.1,0.1-0.1h2.1c0.1,0,0.1,0,0.1,0.1l0.4,2.1c0,0.3,0.2,0.5,0.5,0.6c0.8,0.2,1.5,0.5,2.2,0.9c0.2,0.1,0.5,0.1,0.7,0
		l1.8-1.3c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l1.5,1.5c0,0,0.1,0.1,0,0.2l-1.3,1.8c-0.2,0.2-0.2,0.5,0,0.7c0.4,0.7,0.7,1.4,0.9,2.1
		c0.1,0.3,0.3,0.5,0.6,0.5l2.1,0.4c0.1,0,0.1,0.1,0.1,0.1V31.4z"
                        />
                        <path
                            className={classesInline.ColorFill}
                            d="M152.3,25c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3c2.9,0,5.3-2.4,5.3-5.3S155.2,25,152.3,25z M152.3,34.2
		c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9S154.5,34.2,152.3,34.2z"
                        />
                    </g>
                </svg>
            </div>
        </>
    );
};

export default SettingButton;
